import { Person } from 'talent_matching/types';

export const hasApplicationQuestions = (application?: Person | null) => {
  return (
    (application?.applicationQuestions?.length ?? 0) > 0 ||
    (application?.agencyQuestions?.length ?? 0) > 0 ||
    (application?.referralDetails?.length ?? 0) > 0
  );
};

export const hasApplicationHistory = (application?: Person | null) => {
  return Boolean(application?.hasOtherApplications);
};

export const hasResume = (application?: Person | null) => {
  return (
    Boolean(application?.resume?.document) ||
    (application?.attachments?.length ?? 0) > 0
  );
};

export const hasFeedback = (application?: Person | null) => {
  return (application?.scorecards?.length ?? 0) > 0;
};

export const isSidePanelTabVisible = (
  application: Person | null,
  tabId: string
) => {
  switch (tabId) {
    case 'application':
      return hasApplicationQuestions(application);
    case 'resume':
      return hasResume(application);
    case 'application_history':
      return hasApplicationHistory(application);
    case 'feedback':
      return hasFeedback(application);
    case 'work_preferences':
      return true;
    case 'match_report':
      return true;
    default:
      return false;
  }
};

export const getDefaultSidePanelTab = (application?: Person | null) => {
  if (hasApplicationQuestions(application)) {
    return 'application';
  }

  if (hasApplicationHistory(application)) {
    return 'application_history';
  }

  return 'resume';
};
